/** Everything that differs between the player's five weapons. */
export interface WeaponStats {
  /** HUD / message-box label. */
  readonly name: string;
  /** `SoundFX` method played by a normal slash. */
  readonly swipeSound: "swipe" | "swipeB" | "swipeC" | "swipeD" | "swipeE";
  /** Base slash damage, before the sword-level multiplier. */
  readonly damage: number;
  /** Base special-attack damage, before the sword-level multiplier. */
  readonly damageSpecial: number;
  /** Energy the special attack costs. */
  readonly specialCost: number;
  /** Slash reach at zero energy, in pixels. */
  readonly range: number;
  /** How much stored energy stretches the blade sprite. */
  readonly scaleMult: number;
  /** How much stored energy adds to `range`. */
  readonly growth: number;
}

/** Indexed by the player's weapon id, 0-4. */
export const WEAPONS: readonly WeaponStats[] = [
  {
    name: "X-SABRE",
    swipeSound: "swipeB",
    damage: 10,
    damageSpecial: 9,
    specialCost: 200,
    range: 31,
    scaleMult: 0.27,
    growth: 11,
  },
  {
    name: "S-HURRICANE",
    swipeSound: "swipeD",
    damage: 9,
    damageSpecial: 7,
    specialCost: 250,
    range: 34,
    scaleMult: 0.27,
    growth: 15,
  },
  {
    name: "E-CRUSHER",
    swipeSound: "swipe",
    damage: 13,
    damageSpecial: 15,
    specialCost: 375,
    range: 36,
    scaleMult: 0.19,
    growth: 12,
  },
  {
    name: "G-SLICER",
    swipeSound: "swipeC",
    damage: 9,
    damageSpecial: 3,
    specialCost: 350,
    range: 56,
    scaleMult: 0.27,
    growth: 24,
  },
  {
    name: "MEGATRON",
    swipeSound: "swipeE",
    damage: 12,
    damageSpecial: 15,
    specialCost: 450,
    range: 39,
    scaleMult: 0.27,
    growth: 16,
  },
];
